import { useEffect } from "react";

const useIntersectionObserver = (className: string, addClass: string, threshold: number = 1) => {
  useEffect(() => {
    let intersectionObserver: IntersectionObserver;

    // This function sets up and returns an observer. It's called to create the initial observer.
    const createObserver = () => {
      return new IntersectionObserver(
        (entries) => {
          // YOUR ORIGINAL STAGGERING AND REVERSIBLE LOGIC - UNCHANGED
          const visibleEntries = entries.filter(entry => entry.intersectionRatio >= threshold);
          const hiddenEntries = entries.filter(entry => entry.intersectionRatio === 0);

          visibleEntries.forEach((entry, index) => {
            const element = entry.target as HTMLElement;
            if (!element.classList.contains(addClass)) {
              element.classList.add(addClass);
              element.style.animationDelay = `${index * 300}ms`;
            }
          });

          hiddenEntries.forEach((entry) => {
            const element = entry.target as HTMLElement;
            if (element.classList.contains(addClass)) {
              element.classList.remove(addClass);
              element.style.animationDelay = "0ms";
            }
          });
        },
        {
          root: null,
          threshold: [0, threshold],
        }
      );
    };

    // Create the one and only IntersectionObserver
    intersectionObserver = createObserver();

    // Observe all elements that exist on initial load
    document.querySelectorAll<HTMLElement>(`.${className}`).forEach((el) => {
      intersectionObserver.observe(el);
    });

    // --- START OF THE FIX ---
    // The new, intelligent MutationObserver that DOES NOT destroy the IntersectionObserver.
    const mutationObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            // Check if the added node is an element we can query
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as HTMLElement;
              // If the added element itself matches, observe it
              if (element.matches(`.${className}`)) {
                intersectionObserver.observe(element);
              }
              // Find any matching children within the added element and observe them
              element.querySelectorAll<HTMLElement>(`.${className}`).forEach((child) => {
                intersectionObserver.observe(child);
              });
            }
          });
        }
      }
    });
    // --- END OF THE FIX ---

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      // Standard cleanup
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [className, addClass, threshold]);
};

export default useIntersectionObserver;